import React from 'react';
import styles from './ProfessorWelcome.module.css';

function Button({ children, className = '', variant = 'solid', disabled = false, ...props }) {
  const baseClass = styles.buttonBase;
  const variantClass = variant === 'outline' ? styles.buttonOutline : styles.buttonSolid;
  const disabledClass = disabled ? styles.buttonDisabled : '';
  
  return (
    <button
      className={`${baseClass} ${variantClass} ${disabledClass} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;